export enum SupportedISOCodes {
  'es',
  'en',
  'pt'
}

export type SupportedISOCode = keyof typeof SupportedISOCodes;

export interface LokaliseKey {
  isoCode: SupportedISOCode;
  lokaliseKey: string;
}
